import { render, staticRenderFns } from "./AddProvideUser.vue?vue&type=template&id=3702e78e&scoped=true"
import script from "./AddProvideUser.vue?vue&type=script&lang=js"
export * from "./AddProvideUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3702e78e",
  null
  
)

export default component.exports